module.exports = __webpack_public_path__ + "static/media/loader.49754e9e.gif";